import { HttpHeaders } from '../interfaces';

const toHeadersFromHttpHeaders = (headers?: HttpHeaders): Headers => {
  const out = new Headers();
  if (headers) {
    headers.forEach((value, key) => out.set(key, value));
  }
  return out;
};
export default toHeadersFromHttpHeaders;
